/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { IconPlus, IconX } from "@tabler/icons-react";
import { useFieldArray } from "react-hook-form";
import { useWatch } from "react-hook-form";

export default function EditRowModal({
  open,
  onClose,
  register,
  setValue,
  control,
  errors,
  handleSubmit,
  isPending,
  defaultValues,
}: any) {
  const { fields, replace, append } = useFieldArray({
    control,
    name: "levels",
  });

  const levels = useWatch({
  control,
  name: "levels",
});

  // ✅ Prefill
  useEffect(() => {
    if (defaultValues && open) {
      setValue("rackName", defaultValues?.name || "");

      // 👉 set levels array
      const levelData =
        defaultValues?.levels?.map((lvl: any) => ({
          id: lvl.id, // ✅ MUST
          name: lvl.name,
        })) || [];

      replace(levelData);
    }
  }, [defaultValues, open]);

  if (!open) return null;

  const handleAddLevel = () => {
  if (fields.length < 4) {
    append({ name: "" });
  }
};

  const hasEmptyLevel = levels?.some(
    (lvl: any) => !lvl?.name || lvl.name.trim() === ""
  );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-[#F7F6F2] rounded-3xl w-[500px] flex flex-col">
        {/* Header */}
        <div className="flex justify-between px-4 py-3 border-b">
          <h2>Edit Row</h2>
          <button onClick={onClose}>
            <IconX />
          </button>
        </div>

        {/* Body */}
        <div className="p-4 space-y-4">
          {/* Rack */}
          <div>
            <label>Rack Name</label>
            <input
              {...register("rackName", { required: true })}
              className="w-full border rounded-full px-4 py-2"
            />
          </div>

          {/* Levels */}
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <h2>Levels</h2>
              <button
                type="button"
                onClick={handleAddLevel}
                disabled={fields.length >= 4 || hasEmptyLevel}
                className={`flex items-center justify-center w-12 h-12 rounded-full border 
                ${
                  fields.length >= 4 || hasEmptyLevel
                    ? "opacity-50 cursor-not-allowed"
                    : "bg-[#F7F6F2] hover:shadow"
                }`}
              >
                <IconPlus stroke={1.5} size={24} />
              </button>
            </div>

            {fields.map((field, index) => (
              <input
                key={field.id}
                {...register(`levels.${index}.name`)}
                className="w-full border rounded-full px-4 py-2"
                placeholder={`Level ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end p-4 border-t">
          <button
            onClick={handleSubmit}
            disabled={isPending || hasEmptyLevel}
            className="px-4 py-2 rounded-full bg-[#FBD037] disabled:opacity-50"
          >
            {isPending ? "Updating..." : "Update"}
          </button>
        </div>
      </div>
    </div>
  );
}
